// extracted by mini-css-extract-plugin
export var btn = "z_b";
export var footer = "z_V";
export var formInner = "z_X";
export var formStyle = "z_W";
export var legal = "z_Y";
export var smooth = "z_d";
export var submit = "z_c";